import { useTranslation } from 'react-i18next'
import { OnboardingStayFocusedIcon } from '@/src/renderer/components/icons/OnboardingStayFocusedIcon'

export function StayFocusedSlide() {
  const { t } = useTranslation()

  return (
    <div className="onboarding-page__slide">
      <OnboardingStayFocusedIcon />
      <div className="onboarding-page__text-container">
        <h1 className="onboarding-page__title">{t('onboarding.stayFocused.title')}</h1>
        <p className="onboarding-page__description">
          {t('onboarding.stayFocused.description')}
        </p>
      </div>
    </div>
  )
}
